var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#723fa3",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.441095, 51.710136)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.984375 0 L 11.890625 -29.84375 L 18.03125 -29.84375 L 28.9375 0 L 23.140625 0 L 20.765625 -6.90625 L 9.125 -6.90625 L 6.6875 0 Z M 10.609375 -11.171875 L 19.265625 -11.171875 L 14.921875 -23.578125 Z M 10.609375 -11.171875 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#723fa3",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.325246, 51.710136)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.765625 0 L 2.765625 -30.6875 L 8.234375 -30.6875 L 8.234375 0 Z M 2.765625 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#723fa3",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.366585, 51.710136)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.765625 0 L 2.765625 -30.6875 L 8.234375 -30.6875 L 8.234375 0 Z M 2.765625 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeAllIcon);
export default __webpack_public_path__ + "static/media/Recipe - All Icon.93c43b5863bcf9370c83683d18e09e47.svg";
export { ForwardRef as ReactComponent };